import React, { useState, useEffect } from 'react';
import { FaPhone, FaCheck, FaTimes, FaChevronDown, FaGlobe } from 'react-icons/fa';
import { detectUserCountry } from '../utils/geolocation';

// Complete list of all country codes with flags
const COUNTRY_CODES = [
  // Popular countries first
  { code: 'US', name: 'United States', phone: '+1', flag: '🇺🇸' },
  { code: 'CA', name: 'Canada', phone: '+1', flag: '🇨🇦' },
  { code: 'GB', name: 'United Kingdom', phone: '+44', flag: '🇬🇧' },
  { code: 'FR', name: 'France', phone: '+33', flag: '🇫🇷' },
  { code: 'DE', name: 'Germany', phone: '+49', flag: '🇩🇪' },
  { code: 'ES', name: 'Spain', phone: '+34', flag: '🇪🇸' },
  { code: 'IT', name: 'Italy', phone: '+39', flag: '🇮🇹' },
  { code: 'AU', name: 'Australia', phone: '+61', flag: '🇦🇺' },
  { code: 'JP', name: 'Japan', phone: '+81', flag: '🇯🇵' },
  { code: 'CN', name: 'China', phone: '+86', flag: '🇨🇳' },
  { code: 'IN', name: 'India', phone: '+91', flag: '🇮🇳' },
  { code: 'BR', name: 'Brazil', phone: '+55', flag: '🇧🇷' },
  { code: 'MX', name: 'Mexico', phone: '+52', flag: '🇲🇽' },
  { code: 'MA', name: 'Morocco', phone: '+212', flag: '🇲🇦' },
  { code: 'NL', name: 'Netherlands', phone: '+31', flag: '🇳🇱' },
  
  // All other countries alphabetically
  { code: 'AD', name: 'Andorra', phone: '+376', flag: '🇦🇩' },
  { code: 'AE', name: 'United Arab Emirates', phone: '+971', flag: '🇦🇪' },
  { code: 'AF', name: 'Afghanistan', phone: '+93', flag: '🇦🇫' },
  { code: 'AG', name: 'Antigua and Barbuda', phone: '+1268', flag: '🇦🇬' },
  { code: 'AI', name: 'Anguilla', phone: '+1264', flag: '🇦🇮' },
  { code: 'AL', name: 'Albania', phone: '+355', flag: '🇦🇱' },
  { code: 'AM', name: 'Armenia', phone: '+374', flag: '🇦🇲' },
  { code: 'AO', name: 'Angola', phone: '+244', flag: '🇦🇴' },
  { code: 'AQ', name: 'Antarctica', phone: '+672', flag: '🇦🇶' },
  { code: 'AR', name: 'Argentina', phone: '+54', flag: '🇦🇷' },
  { code: 'AS', name: 'American Samoa', phone: '+1684', flag: '🇦🇸' },
  { code: 'AT', name: 'Austria', phone: '+43', flag: '🇦🇹' },
  { code: 'AW', name: 'Aruba', phone: '+297', flag: '🇦🇼' },
  { code: 'AX', name: 'Åland Islands', phone: '+358', flag: '🇦🇽' },
  { code: 'AZ', name: 'Azerbaijan', phone: '+994', flag: '🇦🇿' },
  { code: 'BA', name: 'Bosnia and Herzegovina', phone: '+387', flag: '🇧🇦' },
  { code: 'BB', name: 'Barbados', phone: '+1246', flag: '🇧🇧' },
  { code: 'BD', name: 'Bangladesh', phone: '+880', flag: '🇧🇩' },
  { code: 'BE', name: 'Belgium', phone: '+32', flag: '🇧🇪' },
  { code: 'BF', name: 'Burkina Faso', phone: '+226', flag: '🇧🇫' },
  { code: 'BG', name: 'Bulgaria', phone: '+359', flag: '🇧🇬' },
  { code: 'BH', name: 'Bahrain', phone: '+973', flag: '🇧🇭' },
  { code: 'BI', name: 'Burundi', phone: '+257', flag: '🇧🇮' },
  { code: 'BJ', name: 'Benin', phone: '+229', flag: '🇧🇯' },
  { code: 'BL', name: 'Saint Barthélemy', phone: '+590', flag: '🇧🇱' },
  { code: 'BM', name: 'Bermuda', phone: '+1441', flag: '🇧🇲' },
  { code: 'BN', name: 'Brunei', phone: '+673', flag: '🇧🇳' },
  { code: 'BO', name: 'Bolivia', phone: '+591', flag: '🇧🇴' },
  { code: 'BQ', name: 'Caribbean Netherlands', phone: '+599', flag: '🇧🇶' },
  { code: 'BS', name: 'Bahamas', phone: '+1242', flag: '🇧🇸' },
  { code: 'BT', name: 'Bhutan', phone: '+975', flag: '🇧🇹' },
  { code: 'BV', name: 'Bouvet Island', phone: '+47', flag: '🇧🇻' },
  { code: 'BW', name: 'Botswana', phone: '+267', flag: '🇧🇼' },
  { code: 'BY', name: 'Belarus', phone: '+375', flag: '🇧🇾' },
  { code: 'BZ', name: 'Belize', phone: '+501', flag: '🇧🇿' },
  { code: 'CC', name: 'Cocos Islands', phone: '+61', flag: '🇨🇨' },
  { code: 'CD', name: 'DR Congo', phone: '+243', flag: '🇨🇩' },
  { code: 'CF', name: 'Central African Republic', phone: '+236', flag: '🇨🇫' },
  { code: 'CG', name: 'Republic of the Congo', phone: '+242', flag: '🇨🇬' },
  { code: 'CH', name: 'Switzerland', phone: '+41', flag: '🇨🇭' },
  { code: 'CI', name: 'Côte d\'Ivoire', phone: '+225', flag: '🇨🇮' },
  { code: 'CK', name: 'Cook Islands', phone: '+682', flag: '🇨🇰' },
  { code: 'CL', name: 'Chile', phone: '+56', flag: '🇨🇱' },
  { code: 'CM', name: 'Cameroon', phone: '+237', flag: '🇨🇲' },
  { code: 'CO', name: 'Colombia', phone: '+57', flag: '🇨🇴' },
  { code: 'CR', name: 'Costa Rica', phone: '+506', flag: '🇨🇷' },
  { code: 'CU', name: 'Cuba', phone: '+53', flag: '🇨🇺' },
  { code: 'CV', name: 'Cape Verde', phone: '+238', flag: '🇨🇻' },
  { code: 'CW', name: 'Curaçao', phone: '+599', flag: '🇨🇼' },
  { code: 'CX', name: 'Christmas Island', phone: '+61', flag: '🇨🇽' },
  { code: 'CY', name: 'Cyprus', phone: '+357', flag: '🇨🇾' },
  { code: 'CZ', name: 'Czech Republic', phone: '+420', flag: '🇨🇿' },
  { code: 'DJ', name: 'Djibouti', phone: '+253', flag: '🇩🇯' },
  { code: 'DK', name: 'Denmark', phone: '+45', flag: '🇩🇰' },
  { code: 'DM', name: 'Dominica', phone: '+1767', flag: '🇩🇲' },
  { code: 'DO', name: 'Dominican Republic', phone: '+1809', flag: '🇩🇴' },
  { code: 'DZ', name: 'Algeria', phone: '+213', flag: '🇩🇿' },
  { code: 'EC', name: 'Ecuador', phone: '+593', flag: '🇪🇨' },
  { code: 'EE', name: 'Estonia', phone: '+372', flag: '🇪🇪' },
  { code: 'EG', name: 'Egypt', phone: '+20', flag: '🇪🇬' },
  { code: 'EH', name: 'Western Sahara', phone: '+212', flag: '🇪🇭' },
  { code: 'ER', name: 'Eritrea', phone: '+291', flag: '🇪🇷' },
  { code: 'ET', name: 'Ethiopia', phone: '+251', flag: '🇪🇹' },
  { code: 'FI', name: 'Finland', phone: '+358', flag: '🇫🇮' },
  { code: 'FJ', name: 'Fiji', phone: '+679', flag: '🇫🇯' },
  { code: 'FK', name: 'Falkland Islands', phone: '+500', flag: '🇫🇰' },
  { code: 'FM', name: 'Micronesia', phone: '+691', flag: '🇫🇲' },
  { code: 'FO', name: 'Faroe Islands', phone: '+298', flag: '🇫🇴' },
  { code: 'GA', name: 'Gabon', phone: '+241', flag: '🇬🇦' },
  { code: 'GD', name: 'Grenada', phone: '+1473', flag: '🇬🇩' },
  { code: 'GE', name: 'Georgia', phone: '+995', flag: '🇬🇪' },
  { code: 'GF', name: 'French Guiana', phone: '+594', flag: '🇬🇫' },
  { code: 'GG', name: 'Guernsey', phone: '+44', flag: '🇬🇬' },
  { code: 'GH', name: 'Ghana', phone: '+233', flag: '🇬🇭' },
  { code: 'GI', name: 'Gibraltar', phone: '+350', flag: '🇬🇮' },
  { code: 'GL', name: 'Greenland', phone: '+299', flag: '🇬🇱' },
  { code: 'GM', name: 'Gambia', phone: '+220', flag: '🇬🇲' },
  { code: 'GN', name: 'Guinea', phone: '+224', flag: '🇬🇳' },
  { code: 'GP', name: 'Guadeloupe', phone: '+590', flag: '🇬🇵' },
  { code: 'GQ', name: 'Equatorial Guinea', phone: '+240', flag: '🇬🇶' },
  { code: 'GR', name: 'Greece', phone: '+30', flag: '🇬🇷' },
  { code: 'GS', name: 'South Georgia', phone: '+500', flag: '🇬🇸' },
  { code: 'GT', name: 'Guatemala', phone: '+502', flag: '🇬🇹' },
  { code: 'GU', name: 'Guam', phone: '+1671', flag: '🇬🇺' },
  { code: 'GW', name: 'Guinea-Bissau', phone: '+245', flag: '🇬🇼' },
  { code: 'GY', name: 'Guyana', phone: '+592', flag: '🇬🇾' },
  { code: 'HK', name: 'Hong Kong', phone: '+852', flag: '🇭🇰' },
  { code: 'HM', name: 'Heard Island', phone: '+672', flag: '🇭🇲' },
  { code: 'HN', name: 'Honduras', phone: '+504', flag: '🇭🇳' },
  { code: 'HR', name: 'Croatia', phone: '+385', flag: '🇭🇷' },
  { code: 'HT', name: 'Haiti', phone: '+509', flag: '🇭🇹' },
  { code: 'HU', name: 'Hungary', phone: '+36', flag: '🇭🇺' },
  { code: 'ID', name: 'Indonesia', phone: '+62', flag: '🇮🇩' },
  { code: 'IE', name: 'Ireland', phone: '+353', flag: '🇮🇪' },
  { code: 'IL', name: 'Israel', phone: '+972', flag: '🇮🇱' },
  { code: 'IM', name: 'Isle of Man', phone: '+44', flag: '🇮🇲' },
  { code: 'IO', name: 'British Indian Ocean Territory', phone: '+246', flag: '🇮🇴' },
  { code: 'IQ', name: 'Iraq', phone: '+964', flag: '🇮🇶' },
  { code: 'IR', name: 'Iran', phone: '+98', flag: '🇮🇷' },
  { code: 'IS', name: 'Iceland', phone: '+354', flag: '🇮🇸' },
  { code: 'JE', name: 'Jersey', phone: '+44', flag: '🇯🇪' },
  { code: 'JM', name: 'Jamaica', phone: '+1876', flag: '🇯🇲' },
  { code: 'JO', name: 'Jordan', phone: '+962', flag: '🇯🇴' },
  { code: 'KE', name: 'Kenya', phone: '+254', flag: '🇰🇪' },
  { code: 'KG', name: 'Kyrgyzstan', phone: '+996', flag: '🇰🇬' },
  { code: 'KH', name: 'Cambodia', phone: '+855', flag: '🇰🇭' },
  { code: 'KI', name: 'Kiribati', phone: '+686', flag: '🇰🇮' },
  { code: 'KM', name: 'Comoros', phone: '+269', flag: '🇰🇲' },
  { code: 'KN', name: 'Saint Kitts and Nevis', phone: '+1869', flag: '🇰🇳' },
  { code: 'KP', name: 'North Korea', phone: '+850', flag: '🇰🇵' },
  { code: 'KR', name: 'South Korea', phone: '+82', flag: '🇰🇷' },
  { code: 'KW', name: 'Kuwait', phone: '+965', flag: '🇰🇼' },
  { code: 'KY', name: 'Cayman Islands', phone: '+1345', flag: '🇰🇾' },
  { code: 'KZ', name: 'Kazakhstan', phone: '+7', flag: '🇰🇿' },
  { code: 'LA', name: 'Laos', phone: '+856', flag: '🇱🇦' },
  { code: 'LB', name: 'Lebanon', phone: '+961', flag: '🇱🇧' },
  { code: 'LC', name: 'Saint Lucia', phone: '+1758', flag: '🇱🇨' },
  { code: 'LI', name: 'Liechtenstein', phone: '+423', flag: '🇱🇮' },
  { code: 'LK', name: 'Sri Lanka', phone: '+94', flag: '🇱🇰' },
  { code: 'LR', name: 'Liberia', phone: '+231', flag: '🇱🇷' },
  { code: 'LS', name: 'Lesotho', phone: '+266', flag: '🇱🇸' },
  { code: 'LT', name: 'Lithuania', phone: '+370', flag: '🇱🇹' },
  { code: 'LU', name: 'Luxembourg', phone: '+352', flag: '🇱🇺' },
  { code: 'LV', name: 'Latvia', phone: '+371', flag: '🇱🇻' },
  { code: 'LY', name: 'Libya', phone: '+218', flag: '🇱🇾' },
  { code: 'MC', name: 'Monaco', phone: '+377', flag: '🇲🇨' },
  { code: 'MD', name: 'Moldova', phone: '+373', flag: '🇲🇩' },
  { code: 'ME', name: 'Montenegro', phone: '+382', flag: '🇲🇪' },
  { code: 'MF', name: 'Saint Martin', phone: '+590', flag: '🇲🇫' },
  { code: 'MG', name: 'Madagascar', phone: '+261', flag: '🇲🇬' },
  { code: 'MH', name: 'Marshall Islands', phone: '+692', flag: '🇲🇭' },
  { code: 'MK', name: 'North Macedonia', phone: '+389', flag: '🇲🇰' },
  { code: 'ML', name: 'Mali', phone: '+223', flag: '🇲🇱' },
  { code: 'MM', name: 'Myanmar', phone: '+95', flag: '🇲🇲' },
  { code: 'MN', name: 'Mongolia', phone: '+976', flag: '🇲🇳' },
  { code: 'MO', name: 'Macao', phone: '+853', flag: '🇲🇴' },
  { code: 'MP', name: 'Northern Mariana Islands', phone: '+1670', flag: '🇲🇵' },
  { code: 'MQ', name: 'Martinique', phone: '+596', flag: '🇲🇶' },
  { code: 'MR', name: 'Mauritania', phone: '+222', flag: '🇲🇷' },
  { code: 'MS', name: 'Montserrat', phone: '+1664', flag: '🇲🇸' },
  { code: 'MT', name: 'Malta', phone: '+356', flag: '🇲🇹' },
  { code: 'MU', name: 'Mauritius', phone: '+230', flag: '🇲🇺' },
  { code: 'MV', name: 'Maldives', phone: '+960', flag: '🇲🇻' },
  { code: 'MW', name: 'Malawi', phone: '+265', flag: '🇲🇼' },
  { code: 'MY', name: 'Malaysia', phone: '+60', flag: '🇲🇾' },
  { code: 'MZ', name: 'Mozambique', phone: '+258', flag: '🇲🇿' },
  { code: 'NA', name: 'Namibia', phone: '+264', flag: '🇳🇦' },
  { code: 'NC', name: 'New Caledonia', phone: '+687', flag: '🇳🇨' },
  { code: 'NE', name: 'Niger', phone: '+227', flag: '🇳🇪' },
  { code: 'NF', name: 'Norfolk Island', phone: '+672', flag: '🇳🇫' },
  { code: 'NG', name: 'Nigeria', phone: '+234', flag: '🇳🇬' },
  { code: 'NI', name: 'Nicaragua', phone: '+505', flag: '🇳🇮' },
  { code: 'NO', name: 'Norway', phone: '+47', flag: '🇳🇴' },
  { code: 'NP', name: 'Nepal', phone: '+977', flag: '🇳🇵' },
  { code: 'NR', name: 'Nauru', phone: '+674', flag: '🇳🇷' },
  { code: 'NU', name: 'Niue', phone: '+683', flag: '🇳🇺' },
  { code: 'NZ', name: 'New Zealand', phone: '+64', flag: '🇳🇿' },
  { code: 'OM', name: 'Oman', phone: '+968', flag: '🇴🇲' },
  { code: 'PA', name: 'Panama', phone: '+507', flag: '🇵🇦' },
  { code: 'PE', name: 'Peru', phone: '+51', flag: '🇵🇪' },
  { code: 'PF', name: 'French Polynesia', phone: '+689', flag: '🇵🇫' },
  { code: 'PG', name: 'Papua New Guinea', phone: '+675', flag: '🇵🇬' },
  { code: 'PH', name: 'Philippines', phone: '+63', flag: '🇵🇭' },
  { code: 'PK', name: 'Pakistan', phone: '+92', flag: '🇵🇰' },
  { code: 'PL', name: 'Poland', phone: '+48', flag: '🇵🇱' },
  { code: 'PM', name: 'Saint Pierre and Miquelon', phone: '+508', flag: '🇵🇲' },
  { code: 'PN', name: 'Pitcairn Islands', phone: '+64', flag: '🇵🇳' },
  { code: 'PR', name: 'Puerto Rico', phone: '+1787', flag: '🇵🇷' },
  { code: 'PS', name: 'Palestine', phone: '+970', flag: '🇵🇸' },
  { code: 'PT', name: 'Portugal', phone: '+351', flag: '🇵🇹' },
  { code: 'PW', name: 'Palau', phone: '+680', flag: '🇵🇼' },
  { code: 'PY', name: 'Paraguay', phone: '+595', flag: '🇵🇾' },
  { code: 'QA', name: 'Qatar', phone: '+974', flag: '🇶🇦' },
  { code: 'RE', name: 'Réunion', phone: '+262', flag: '🇷🇪' },
  { code: 'RO', name: 'Romania', phone: '+40', flag: '🇷🇴' },
  { code: 'RS', name: 'Serbia', phone: '+381', flag: '🇷🇸' },
  { code: 'RU', name: 'Russia', phone: '+7', flag: '🇷🇺' },
  { code: 'RW', name: 'Rwanda', phone: '+250', flag: '🇷🇼' },
  { code: 'SA', name: 'Saudi Arabia', phone: '+966', flag: '🇸🇦' },
  { code: 'SB', name: 'Solomon Islands', phone: '+677', flag: '🇸🇧' },
  { code: 'SC', name: 'Seychelles', phone: '+248', flag: '🇸🇨' },
  { code: 'SD', name: 'Sudan', phone: '+249', flag: '🇸🇩' },
  { code: 'SE', name: 'Sweden', phone: '+46', flag: '🇸🇪' },
  { code: 'SG', name: 'Singapore', phone: '+65', flag: '🇸🇬' },
  { code: 'SH', name: 'Saint Helena', phone: '+290', flag: '🇸🇭' },
  { code: 'SI', name: 'Slovenia', phone: '+386', flag: '🇸🇮' },
  { code: 'SJ', name: 'Svalbard and Jan Mayen', phone: '+47', flag: '🇸🇯' },
  { code: 'SK', name: 'Slovakia', phone: '+421', flag: '🇸🇰' },
  { code: 'SL', name: 'Sierra Leone', phone: '+232', flag: '🇸🇱' },
  { code: 'SM', name: 'San Marino', phone: '+378', flag: '🇸🇲' },
  { code: 'SN', name: 'Senegal', phone: '+221', flag: '🇸🇳' },
  { code: 'SO', name: 'Somalia', phone: '+252', flag: '🇸🇴' },
  { code: 'SR', name: 'Suriname', phone: '+597', flag: '🇸🇷' },
  { code: 'SS', name: 'South Sudan', phone: '+211', flag: '🇸🇸' },
  { code: 'ST', name: 'São Tomé and Príncipe', phone: '+239', flag: '🇸🇹' },
  { code: 'SV', name: 'El Salvador', phone: '+503', flag: '🇸🇻' },
  { code: 'SX', name: 'Sint Maarten', phone: '+1721', flag: '🇸🇽' },
  { code: 'SY', name: 'Syria', phone: '+963', flag: '🇸🇾' },
  { code: 'SZ', name: 'Eswatini', phone: '+268', flag: '🇸🇿' },
  { code: 'TC', name: 'Turks and Caicos Islands', phone: '+1649', flag: '🇹🇨' },
  { code: 'TD', name: 'Chad', phone: '+235', flag: '🇹🇩' },
  { code: 'TF', name: 'French Southern Territories', phone: '+262', flag: '🇹🇫' },
  { code: 'TG', name: 'Togo', phone: '+228', flag: '🇹🇬' },
  { code: 'TH', name: 'Thailand', phone: '+66', flag: '🇹🇭' },
  { code: 'TJ', name: 'Tajikistan', phone: '+992', flag: '🇹🇯' },
  { code: 'TK', name: 'Tokelau', phone: '+690', flag: '🇹🇰' },
  { code: 'TL', name: 'Timor-Leste', phone: '+670', flag: '🇹🇱' },
  { code: 'TM', name: 'Turkmenistan', phone: '+993', flag: '🇹🇲' },
  { code: 'TN', name: 'Tunisia', phone: '+216', flag: '🇹🇳' },
  { code: 'TO', name: 'Tonga', phone: '+676', flag: '🇹🇴' },
  { code: 'TR', name: 'Turkey', phone: '+90', flag: '🇹🇷' },
  { code: 'TT', name: 'Trinidad and Tobago', phone: '+1868', flag: '🇹🇹' },
  { code: 'TV', name: 'Tuvalu', phone: '+688', flag: '🇹🇻' },
  { code: 'TW', name: 'Taiwan', phone: '+886', flag: '🇹🇼' },
  { code: 'TZ', name: 'Tanzania', phone: '+255', flag: '🇹🇿' },
  { code: 'UA', name: 'Ukraine', phone: '+380', flag: '🇺🇦' },
  { code: 'UG', name: 'Uganda', phone: '+256', flag: '🇺🇬' },
  { code: 'UM', name: 'U.S. Minor Outlying Islands', phone: '+1', flag: '🇺🇲' },
  { code: 'UY', name: 'Uruguay', phone: '+598', flag: '🇺🇾' },
  { code: 'UZ', name: 'Uzbekistan', phone: '+998', flag: '🇺🇿' },
  { code: 'VA', name: 'Vatican City', phone: '+379', flag: '🇻🇦' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', phone: '+1784', flag: '🇻🇨' },
  { code: 'VE', name: 'Venezuela', phone: '+58', flag: '🇻🇪' },
  { code: 'VG', name: 'British Virgin Islands', phone: '+1284', flag: '🇻🇬' },
  { code: 'VI', name: 'U.S. Virgin Islands', phone: '+1340', flag: '🇻🇮' },
  { code: 'VN', name: 'Vietnam', phone: '+84', flag: '🇻🇳' },
  { code: 'VU', name: 'Vanuatu', phone: '+678', flag: '🇻🇺' },
  { code: 'WF', name: 'Wallis and Futuna', phone: '+681', flag: '🇼🇫' },
  { code: 'WS', name: 'Samoa', phone: '+685', flag: '🇼🇸' },
  { code: 'YE', name: 'Yemen', phone: '+967', flag: '🇾🇪' },
  { code: 'YT', name: 'Mayotte', phone: '+262', flag: '🇾🇹' },
  { code: 'ZA', name: 'South Africa', phone: '+27', flag: '🇿🇦' },
  { code: 'ZM', name: 'Zambia', phone: '+260', flag: '🇿🇲' },
  { code: 'ZW', name: 'Zimbabwe', phone: '+263', flag: '🇿🇼' }
];

const PhoneInput = ({ 
  value, 
  onChange, 
  countryCode: initialCountryCode = 'US', 
  placeholder, 
  className = '',
  required = false 
}) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isValid, setIsValid] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [countryDetected, setCountryDetected] = useState(false);

  // Auto-detect country on mount
  useEffect(() => {
    const initializeCountry = async () => {
      try {
        const detectedCountry = await detectUserCountry();
        console.log('Detected country for phone:', detectedCountry);
        
        const countryData = COUNTRY_CODES.find(c => c.code === detectedCountry) || 
                           COUNTRY_CODES.find(c => c.code === initialCountryCode) ||
                           COUNTRY_CODES[0];
        
        setSelectedCountry(countryData);
        if (detectedCountry && detectedCountry !== initialCountryCode) {
          setCountryDetected(true);
          setTimeout(() => setCountryDetected(false), 5000);
        }
      } catch (error) {
        console.error('Failed to detect country for phone:', error);
        const defaultCountry = COUNTRY_CODES.find(c => c.code === initialCountryCode) || COUNTRY_CODES[0];
        setSelectedCountry(defaultCountry);
      }
    };

    initializeCountry();
  }, [initialCountryCode]);

  // Parse existing value
  useEffect(() => {
    if (value && value !== `${selectedCountry?.phone || ''} ${phoneNumber}`.trim()) {
      // Try to extract phone number from existing value
      const cleanValue = value.toString().trim();
      
      // Check if it starts with a country code
      const matchingCountry = COUNTRY_CODES.find(c => cleanValue.startsWith(c.phone));
      if (matchingCountry) {
        setSelectedCountry(matchingCountry);
        setPhoneNumber(cleanValue.replace(matchingCountry.phone, '').trim());
      } else {
        setPhoneNumber(cleanValue);
      }
    }
  }, [value, selectedCountry]);

  // Simple validation
  useEffect(() => {
    if (phoneNumber.length > 6) {
      setIsValid(true);
    } else if (phoneNumber.length > 0) {
      setIsValid(false);
    } else {
      setIsValid(null);
    }
  }, [phoneNumber]);

  const handlePhoneChange = (e) => {
    const inputValue = e.target.value;
    setPhoneNumber(inputValue);
    
    // Combine country code with phone number
    const fullNumber = selectedCountry ? `${selectedCountry.phone} ${inputValue}`.trim() : inputValue;
    onChange(fullNumber);
  };

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setShowDropdown(false);
    
    // Update full number with new country code
    const fullNumber = `${country.phone} ${phoneNumber}`.trim();
    onChange(fullNumber);
  };

  const getValidationIcon = () => {
    if (isValid === null || phoneNumber.length === 0) return null;
    
    return isValid ? (
      <FaCheck size={14} style={{ color: '#48bb78' }} />
    ) : (
      <FaTimes size={14} style={{ color: '#e53e3e' }} />
    );
  };

  return (
    <div className="phone-input-container" style={{ position: 'relative' }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        border: `2px solid ${isFocused ? '#3182ce' : isValid === false ? '#e53e3e' : isValid === true ? '#48bb78' : '#e2e8f0'}`,
        borderRadius: '6px',
        backgroundColor: 'white',
        transition: 'border-color 0.2s'
      }}>
        
        {/* Country Code Dropdown */}
        <div style={{ position: 'relative' }}>
          <button
            type="button"
            onClick={() => setShowDropdown(!showDropdown)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '12px',
              border: 'none',
              backgroundColor: 'transparent',
              cursor: 'pointer',
              fontSize: '14px',
              borderRight: '1px solid #e2e8f0'
            }}
          >
            <span style={{ fontSize: '16px' }}>{selectedCountry?.flag || '🌍'}</span>
            <span style={{ fontWeight: '500', color: '#2d3748' }}>{selectedCountry?.phone || '+1'}</span>
            <FaChevronDown size={10} style={{ color: '#718096' }} />
          </button>

          {/* Country Detection Indicator */}
          {countryDetected && (
            <div style={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              backgroundColor: '#48bb78',
              color: 'white',
              borderRadius: '50%',
              width: '16px',
              height: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '8px'
            }}>
              <FaGlobe size={8} />
            </div>
          )}

          {/* Dropdown */}
          {showDropdown && (
            <div style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              backgroundColor: 'white',
              border: '1px solid #e2e8f0',
              borderRadius: '6px',
              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
              zIndex: 1000,
              maxHeight: '200px',
              overflowY: 'auto',
              minWidth: '200px'
            }}>
              {COUNTRY_CODES.map((country) => (
                <button
                  key={country.code}
                  type="button"
                  onClick={() => handleCountrySelect(country)}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 12px',
                    border: 'none',
                    backgroundColor: selectedCountry?.code === country.code ? '#f7fafc' : 'transparent',
                    cursor: 'pointer',
                    fontSize: '14px',
                    textAlign: 'left'
                  }}
                  onMouseEnter={(e) => {
                    if (selectedCountry?.code !== country.code) {
                      e.target.style.backgroundColor = '#f7fafc';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedCountry?.code !== country.code) {
                      e.target.style.backgroundColor = 'transparent';
                    }
                  }}
                >
                  <span style={{ fontSize: '16px' }}>{country.flag}</span>
                  <span style={{ fontWeight: '500' }}>{country.phone}</span>
                  <span style={{ color: '#718096', fontSize: '12px' }}>{country.name}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Phone Number Input */}
        <div style={{ flex: 1, position: 'relative' }}>
          <input
            type="tel"
            value={phoneNumber}
            onChange={handlePhoneChange}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            placeholder={placeholder || "123 456 7890"}
            style={{
              width: '100%',
              padding: '12px',
              border: 'none',
              outline: 'none',
              fontSize: '14px',
              backgroundColor: 'transparent'
            }}
            required={required}
            autoComplete="tel"
          />
          
          {/* Validation Icon */}
          <div style={{
            position: 'absolute',
            right: '12px',
            top: '50%',
            transform: 'translateY(-50%)'
          }}>
            {getValidationIcon()}
          </div>
        </div>
      </div>

      {/* Click outside to close dropdown */}
      {showDropdown && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
          onClick={() => setShowDropdown(false)}
        />
      )}

      {/* Validation Message */}
      {isValid === false && phoneNumber.length > 0 && (
        <div style={{
          fontSize: '12px',
          color: '#e53e3e',
          marginTop: '4px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px'
        }}>
          <FaTimes size={10} />
          Please enter a valid phone number
        </div>
      )}
    </div>
  );
};

export default PhoneInput; 